function NotFound() {
  return <div className="notfound">Page not found !</div>
}

export default NotFound
